import { create } from 'zustand';
import { Tables } from '../types/database.types';
import { persist } from 'zustand/middleware';

export type LetterData = Tables<'letters'>;

interface LetterState {
  letterData: LetterData | null;
  setLetterData: (data: Partial<LetterData>) => void;
  createLetterData: (data: Partial<LetterData>) => void;
  clearLetterData: () => void;
}

export const useLetterStore = create<LetterState>()(
  persist(
    (set, get) => ({
      letterData: null,
      setLetterData: (letterData) => {
        const currentLetterData = get().letterData;
        if (currentLetterData) {
          set({
            letterData: {
              ...currentLetterData,
              ...letterData,
            },
          });
        }
      },
      createLetterData: (data) => {
        // 新しいletterDataを作成（IDとcreated_atは後で設定）
        const newLetterData: LetterData = {
          id: '',
          created_at: new Date().toISOString(),
          from_name: data.from_name || null,
          to_name: data.to_name || null,
          message: data.message || null,
          date: data.date || new Date().toISOString().split('T')[0],
          template_name: data.template_name || 'letter-template01.jpg',
          end_date: data.end_date || null,
        };
        set({ letterData: newLetterData });
      },
      clearLetterData: () => {
        set({ letterData: null });
      },
    }),
    {
      name: 'letter-storage', // localStorageのキー名
      partialize: (state) => ({ letterData: state.letterData }), // 永続化する状態を指定
    }
  )
);
